export enum HeaderMode {
    OFF,
    APPLICATION,
    MARKETING,
}